//
const ReportsCounterIcon = ({ className }: { className?: string }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.9997 8.33333H11.6663C10.7823 8.33333 9.93444 8.68452 9.30932 9.30964C8.6842 9.93477 8.33301 10.7826 8.33301 11.6667V31.6667C8.33301 32.5507 8.6842 33.3986 9.30932 34.0237C9.93444 34.6488 10.7823 35 11.6663 35H28.333C29.2171 35 30.0649 34.6488 30.69 34.0237C31.3152 33.3986 31.6663 32.5507 31.6663 31.6667V11.6667C31.6663 10.7826 31.3152 9.93477 30.69 9.30964C30.0649 8.68452 29.2171 8.33333 28.333 8.33333H24.9997M14.9997 8.33333C14.9997 9.21739 15.3509 10.0652 15.976 10.6904C16.6011 11.3155 17.449 11.6667 18.333 11.6667H21.6663C22.5504 11.6667 23.3982 11.3155 24.0234 10.6904C24.6485 10.0652 24.9997 9.21739 24.9997 8.33333M14.9997 8.33333C14.9997 7.44928 15.3509 6.60143 15.976 5.97631C16.6011 5.35119 17.449 5 18.333 5H21.6663C22.5504 5 23.3982 5.35119 24.0234 5.97631C24.6485 6.60143 24.9997 7.44928 24.9997 8.33333M19.9997 20H24.9997M19.9997 26.6667H24.9997M14.9997 20H15.0163M14.9997 26.6667H15.0163"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReportsCounterIcon;
